import type { FC } from 'react';
import { ImageComponent } from '@/components/Image';
import { useVIP } from '@/modules/vip/hooks';
import { VIP_TO_NAME_MAP } from '../../constants';
import {
  darkTextTiers,
  ScVipBadge,
  ScVipBadgeInner,
  type VipTier,
} from './styled';

export interface IVIPBadgeProps {
  level?: number | null;
}

export const VIPBadge: FC<IVIPBadgeProps> = (props) => {
  const { level } = useVIP();

  const displayLevel = props.level ?? level;

  if (!displayLevel) return null;

  const tier = VIP_TO_NAME_MAP[displayLevel] as VipTier;

  return (
    <ScVipBadge $tier={tier}>
      <ScVipBadgeInner $tier={tier}>
        <ImageComponent
          alt="crown"
          height={12}
          src={
            darkTextTiers.includes(tier)
              ? '/vip/crownDark.svg'
              : '/vip/crownLight.svg'
          }
          width={12}
        />
        VIP {displayLevel}
      </ScVipBadgeInner>
    </ScVipBadge>
  );
};
